<template>
    <ToolButton :Editor="Editor" KnownIcon="TableInsertRowTop" @ToolClick="Editor.chain().focus().addRowBefore().run()">

    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>